import { render, staticRenderFns } from "./single-work-rusted.vue?vue&type=template&id=03c55850&scoped=true&lang=pug&"
import script from "./single-work-rusted.vue?vue&type=script&lang=js&"
export * from "./single-work-rusted.vue?vue&type=script&lang=js&"
import style0 from "./single-work-rusted.vue?vue&type=style&index=0&id=03c55850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c55850",
  null
  
)

export default component.exports